module.exports = __webpack_public_path__ + "static/media/face2.1eaf9550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face2.svg
// module id = 1222
// module chunks = 2